import { useStore } from "../../stores/store"
import { companyModalStore } from "../../stores/companyModalStore"
import { useTranslations } from "../../lib/translations"

export function MembersTab() {
  const t = useTranslations()
  const memberships = useStore(companyModalStore, (s) => s.memberships)
  const loaded = useStore(companyModalStore, (s) => s.loaded)
  const error  = useStore(companyModalStore, (s) => s.loadError)

  if (!loaded) return <div className="cm-tabwrap"><div className="cm-coming-soon">…</div></div>
  if (error)   return <div className="cm-tabwrap"><div className="cm-coming-soon">{error}</div></div>

  const active  = memberships.filter((m) => m.accepted_at)
  const pending = memberships.filter((m) => !m.accepted_at)

  return (
    <div className="cm-tabwrap">
      <table className="cm-table">
        <thead>
          <tr>
            <th>{t("company_modal.members.name")}</th>
            <th>{t("company_modal.members.email")}</th>
            <th>{t("company_modal.members.roles")}</th>
            <th>{t("company_modal.members.joined")}</th>
          </tr>
        </thead>
        <tbody>
          {active.map((m) => <Row key={m.id} m={m} />)}
          {pending.map((m) => <Row key={m.id} m={m} pending />)}
          {active.length === 0 && pending.length === 0 && (
            <tr><td colSpan={4} className="cm-coming-soon">{t("company_modal.members.empty")}</td></tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

function Row({ m, pending }) {
  const t = useTranslations()
  return (
    <tr style={pending ? { opacity: 0.55 } : undefined}>
      <td>{m.user?.name || "—"}</td>
      <td className="mono">{m.user?.email || "—"}</td>
      <td>
        {(m.roles || []).map((r) => (
          <span key={r} className="cm-rolepill">{r}</span>
        ))}
      </td>
      <td className="mono">{m.accepted_at ? new Date(m.accepted_at).toLocaleDateString() : t("company_modal.members.pending")}</td>
    </tr>
  )
}
